import http from "../axios/http-common";

class InterfaceAsesmenGigi {
  getAsesmenGigi(unit, reg) {
    return http.getData(`/asesmen-awal-gigi-mulu/unit/${unit}/register/${reg}`);
  }
  getAsesmenGigiByReg(reg) {
    return http.getData(`/asesmen-awal-gigi-mulut/register/${reg}`);
  }

  private buildPayload(tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id) {
    return {
      tgl_periksa: tgl_periksa,
      register_id: reg,
      pasien_rm: rm,
      data_medis: data_medis,
      oklusi: odontogram_lain["oklusi"],
      torus_palatinus: odontogram_lain["torus_palatinus"],
      torus_mandibularis: odontogram_lain["torus_mandibularis"],
      palatum: odontogram_lain["palatum"],
      diastema: odontogram_lain["diastema"],
      gigi_anomali: odontogram_lain["gigi_anomali"],
      lain_lain: odontogram_lain["lain_lain"],
      d: odontogram_lain["d"],
      m: odontogram_lain["m"],
      f: odontogram_lain["f"],
      jml_photo: odontogram_lain["jml_photo"],
      jenis_photo: odontogram_lain["jenis_photo"],
      jml_rontgen: odontogram_lain["jml_rontgen"],
      jenis_rontgen: odontogram_lain["jenis_rontgen"],
      gambar: odontogram_lain["gambar"],
      dokter_id: dokter_id,
      user_id: user_id
    };
  }

  saveAsesmenGigi(tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id) {
    return http.postData(
      `/asesmen-awal-gigi-mulut`,
      this.buildPayload(tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id)
    );
  }
  editAsesmenGigi(id, tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id) {
    return http.putData(
      `/asesmen-awal-gigi-mulut/${id}`,
      this.buildPayload(tgl_periksa, reg, rm, data_medis, odontogram_lain, dokter_id, user_id)
    );
  }
}
export default new InterfaceAsesmenGigi();
